module.exports = __webpack_public_path__ + "static/media/Dikaiwsi_3.a45d47a0.jpg";